import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { BulkDeleteLotOffersInterface, fetchBulkDeleteLotOffers } from "./fetchBulkDelete";


export const bulkDelete = createAsyncThunk("lotList/fetchBulkDelete", async (args: BulkDeleteLotOffersInterface, { getState }) => {
    const { user } = getState() as RootState;
    const response = await fetchBulkDeleteLotOffers({ ...args, endpoint: user.role });
    return { headers: response.headers, data: response.data, status: response.status };
});

